module.exports = __webpack_public_path__ + "static/portrait-12936b6c9ae2124eaf2905f2a596e605.jpg";